import React, { useEffect, useState } from "react";
import SEOHead from "../section/SeoHead";
import ProfileHero from "./layout/ProfileHero";
import ProfileSidebar from "./layout/ProfileSidebar";
import ProfileContent from "./layout/ProfileContent";
import { useAuth } from "../context/AuthContext";

const Profile = () => {
  const { role } = useAuth();
  const [activeTab, setActiveTab] = useState("personal");
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem("auth_user");
    if (storedUser) {
      const parsed = JSON.parse(storedUser);
      setUserData({
        ...parsed,
        isLawFirm: role === "office_owner",
        subscriptionType: "Gold",
        firmRating: 4.7,
        totalReviews: 127,
        firmDetails: {
          contactNumber: parsed.phone,
          address: "123 Legal Plaza, Suite 200, Los Angeles, CA 90210",
          establishedYear: "2015",
          specialties: ["Immigration Law", "Family Law"],
          licenseNumber: "BAR-2015-001234",
        },
      });
    }
    setLoading(false);
  }, [role]);

  if (loading || !userData) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Profile - Citizen Hub",
    description: "Manage your profile and services on Citizen Hub.",
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <SEOHead
        title="Profile - Citizen Hub"
        description="Manage your profile, forms, and services."
        canonicalUrl="https://citizenhub.com/profile"
        structuredData={structuredData}
      />

      <ProfileHero userData={userData} />

      <section className="py-16 bg-gray-50 min-h-screen">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row gap-8">
            <ProfileSidebar
              userData={userData}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              role={role}
            />
            <ProfileContent
              activeTab={activeTab}
              userData={userData}
              setUserData={setUserData}
              role={role}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Profile;